/** Brief tile label is independent of the generation playbook. */
export function BriefCreativeMode({setId}:{setId:number}) {
 return <span className="text-xs text-muted-foreground" data-testid={`brief-creative-mode-${setId}`}>Ad brief</span>;
}
